__turbopack_context__.v({
  "hideDesktop": "kOzqrq_hideDesktop",
  "hideMobile": "kOzqrq_hideMobile",
  "hideTablet": "kOzqrq_hideTablet",
  "sectionContainer": "kOzqrq_sectionContainer",
  "sectionContent": "kOzqrq_sectionContent",
  "waveBottom": "kOzqrq_waveBottom",
  "waveTop": "kOzqrq_waveTop",
});
